import { BaseApiService } from '../../base-api-service';
import { env } from '../../../environment';

class SidebarMenuController extends BaseApiService {

  public async getLobbyNewGames(partnerId: number): Promise<Array<number>> {
    const url = `${env.origin}/api/lobby/newGames`;
    return await this.http.get(url, { params: { partnerId } });
  }

  public async getNewTournaments(): Promise<number[]> {
    const url = `${env.origin}/api/pgtournaments/update`;
    return await this.http.get(url);
  }

}

export const sidebarMenuController = new SidebarMenuController({ url: env.origin });
